angular

	.module 'App.Repository'
	.factory 'CustomerGroupRepository', ['BaseRepository', (BaseRepository) ->
		class CustomerGroupRepository extends BaseRepository
			@resource = '/customer_groups'
			@isRestricted = true

			findByQuery: (query = null) ->
				if _.isEmpty(query)
					query = do @createQuery

				if not do query.isSorted
					query.sortBy 'name', 'ASC'

				super query

		return new CustomerGroupRepository
	]
